export default `float scale = 1.0;
  float orb = 10000.0; 
  for ( int i = 0; i < 6; i++ ) {
    p = -1.0 + 2.0 * fract( 0.5 * p + 0.5 );
    p -= sign( p ) * 0.1;
    float a = float( i ) * acos( -1.0 ) / 4.0;
    p.xz *= mat2( cos( a ), sin( a ), -sin( a ), cos( a ) );
    float r2 = dot( p, p );
    float k = 0.95 / r2;
    p *= k;
    scale *= k;
    orb = min( orb, r2 );
  }
  float d1 = sqrt( min( min( dot( p.xy, p.xy ), dot( p.yz, p.yz ) ), dot( p.zx, p.zx ) ) ) - 0.02;
  float d2 = abs( p.y );
  float dmi = d2;
  float adr = 0.7 * floor( ( 0.5 * p.y + 0.5 ) * 8.0 ); 
  if ( d1 < d2 ) {
    dmi = d1;
    adr = 0.0;
  }
  return 0.5 * dmi / scale;
}`